import values from 'mout/object/values'
import forOwn from 'mout/object/forOwn'
import getSubtest from "./getSubtest";
import sortByPropText from '../content/manageSets/sortByPropText';
import checkRating from './checkRating';
import totalArray from '../totalArray';


export default function getMotivationRating(userAssessment, studentScoring) {
  const ratingThresholds = {
    'English': [
      {percent: 5, rating: 5},
      {percent: 10, rating: 4},
      {percent: 25, rating: 3},
      {percent: 35, rating: 2},
      {percent: 36, rating: 1},
    ],
    'Math': [
      {percent: 5, rating: 5},
      {percent: 10, rating: 4},
      {percent: 25, rating: 3},
      {percent: 35, rating: 2},
      {percent: 36, rating: 1},
    ],
    'Reading': [
      {percent: 5, rating: 5},
      {percent: 10, rating: 4},
      {percent: 25, rating: 3},
      {percent: 35, rating: 2},
      {percent: 36, rating: 1},
    ],
    'Science': [
      {percent: 5, rating: 5},
      {percent: 10, rating: 4},
      {percent: 25, rating: 3},
      {percent: 35, rating: 2},
      {percent: 36, rating: 1},
    ],
  }

  const itemsToCheck = {
    'English': {START: 30, END: 44},
    'Math': {START: 15, END: 24},
    'Reading': {START: 10, END: 19},
    'Science': {START: 13, END: 20},
  }

  const subtestIds = {
    'English': getSubtest('English', userAssessment).setId,
    'Math': getSubtest('Math', userAssessment).setId,
    'Reading': getSubtest('Reading', userAssessment).setId,
    'Science': getSubtest('Science', userAssessment).setId,
  }

  const randomThresholds = {
    'English': 27,
    'Math': 22,
    'Reading': 27,
    'Science': 27,
  }

  function averageItems(items) {
    let possible = 0, raw = 0
    items.forEach(function tallyItems(item) {
      possible += parseInt(item.possible, 10)
      raw += parseInt(item.raw, 10)
    })
    if (possible) {
      return raw / possible
    } else {
      return 0
    }
  }

  function findAveragesOneStudent(studentScore) {
    const subjAverages = ['English', 'Math', 'Reading', 'Science'].map(function averageOneSubject(subject) {
      const subtestId = subtestIds[subject]
      const byItem = sortByPropText(values(studentScore.scoring.byItem[subtestId]), 'index')
      const check = itemsToCheck[subject]
      const items = byItem.slice(check.START, check.END)
      return {subject, average: averageItems(items)}
    })
    return subjAverages.map(function checkForRandom(subjAv) {
      return {
        random: subjAv.average < randomThresholds[subjAv.subject],
        subject: subjAv.subject,
      }
    })
  }

  function findMotivationScoresAllStudents(studentScoring) {
    const randomsAllStudents = values(studentScoring).map(studentScore => findAveragesOneStudent(studentScore))
    let percentRandoms = {};
    ['English', 'Math', 'Reading', 'Science'].forEach(subj => {
      percentRandoms[subj] = {possible: 0, randoms: 0}
    })
    randomsAllStudents.forEach(function tallyRandoms(randomsOneStudent) {
      randomsOneStudent.forEach((subjAv) => {
        percentRandoms[subjAv.subject].possible++
        if (subjAv.random) {
          percentRandoms[subjAv.subject].randoms++ 
        }
      })
    })
    const scores = {}
    forOwn(percentRandoms, (data, subject) => {
      if (data.possible) {
        scores[subject] = data.randoms / data.possible * 100
      } else {
        scores[subject] = 100
      }
    })
    return scores
  }

  function checkMotivationRatings(studentScoring) {
    const scores = findMotivationScoresAllStudents(studentScoring)
    let ratings = {}
    const ratingTest = (r, score) => score < r.percent
    forOwn(scores, (score, subj) => {
      ratings[subj] = checkRating(ratingThresholds, subj, score, ratingTest)
    })
    ratings.stars = Math.round(totalArray(values(ratings)) / 4)
    return ratings
  }

  return checkMotivationRatings(studentScoring)
}

/*

MOTIVATION
What percentage of students have near-guess percentage corrects early on in the test?
English: Passage 3, <27%
Math: Questions 16-25, <22%
Reading: Passage 2, <27%
Science: Passage 3, <27%

5: <5%
4: <10%
3: <25%
2: <35%
1: >=35%

*/


// WEBPACK FOOTER //
// ./src/helpers/assessment/getMotivationRating.js